const imageAspectRatio = (root) => {
  const block = root.closest(".sqs-block-image");
  if (root.dataset.isMaskApplied === "true") {
    const heightPercent = Number(block?.dataset.aspectRatio) || 100;
    return 100 / heightPercent;
  }

  const dimensions = root
    .querySelector("img[data-image-dimensions]")
    ?.getAttribute("data-image-dimensions")
    ?.split("x")
    .map(Number);
  if (
    !dimensions ||
    dimensions.length !== 2 ||
    !dimensions.every(Number.isFinite) ||
    !dimensions[1]
  ) {
    return 1;
  }
  return dimensions[0] / dimensions[1];
};

const clearRuntimeSizing = (root) => {
  [
    "--image-component-object-fit",
    "--image-component-native-aspect-ratio",
    "--image-component-container-width",
    "--image-component-container-height",
  ].forEach((property) => root.style.removeProperty(property));
};

const sizeImage = (root) => {
  const width = root.clientWidth;
  const height = root.clientHeight;
  const aspectRatio = imageAspectRatio(root);
  if (!width || !height || !aspectRatio) return;

  const isMask = root.dataset.isMaskApplied === "true";
  root.style.setProperty(
    "--image-component-object-fit",
    isMask ? "cover" : "contain",
  );
  root.style.setProperty(
    "--image-component-native-aspect-ratio",
    String(aspectRatio),
  );

  if (width / height > aspectRatio) {
    root.style.setProperty("--image-component-container-height", "100%");
    root.style.setProperty(
      "--image-component-container-width",
      `${height * aspectRatio}px`,
    );
  } else {
    root.style.setProperty("--image-component-container-width", "100%");
    root.style.setProperty(
      "--image-component-container-height",
      `${width / aspectRatio}px`,
    );
  }
};

export default function initializeFluidImages(root) {
  const roots = [
    ...root.querySelectorAll(".fluid-image-component-root"),
  ];

  const resize = () => {
    roots.forEach(clearRuntimeSizing);
    // Squarespace sizes unmasked, intrinsic images first because they can
    // determine Fluid Engine's auto rows. Masks are measured after that reflow.
    roots
      .filter((imageRoot) => imageRoot.dataset.isMaskApplied !== "true")
      .forEach(sizeImage);
    roots[0]?.getBoundingClientRect();
    roots
      .filter((imageRoot) => imageRoot.dataset.isMaskApplied === "true")
      .forEach(sizeImage);
  };

  resize();
  window.addEventListener("resize", resize);
  return {
    destroy: () => window.removeEventListener("resize", resize),
    resize,
  };
}
